import { Injectable } from '@angular/core';
import { HttpService } from 'src/app/@core/services/http.service';
import { RptConfig } from '../_rptlanding-url.config';
import { IEmbedConfig } from '../_entities/embedConfig.model';
import { HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ReportLandingService {

  constructor(private http: HttpService) { }


  getProjectsFrReport(userId) {
    return this.http.get(RptConfig.EndPoint.Reportviewer.GetProjectsFrReport + '/' + userId);
  }
  getReports(val) {
    return this.http.get(RptConfig.EndPoint.Reportviewer.GetReports + '/' + val);
  }
  getEmbedReports(val, rolename,wrkspaceid) {
    return this.http.get(RptConfig.EndPoint.Reportviewer.GetEmbedReports +
      '?roles=' + rolename + '&ReportId=' + val  + '&WorkspaceId=' + wrkspaceid );
  }

  /**
   * getEmbedReport
   */
  public GetEmbedReport(ReportId: string): Observable<HttpResponse<IEmbedConfig>> {
    // ReportId = ReportId
    return this.http.get(
      RptConfig.EndPoint.Reportviewer.GetEmbedReports + '?ReportId=' + ReportId);
  }
  /**
   * getEmbedDashboard
   */
  public EmbedDashboard(): Observable<HttpResponse<IEmbedConfig>> {
    return this.http.get(
      RptConfig.EndPoint.Reportviewer.GetEmbedDashboard, { observe: 'response' });
  }
  /**
   * getEmbedTile
   */
  public EmbedTile(): Observable<HttpResponse<IEmbedConfig>> {
    return this.http.get(
      RptConfig.EndPoint.Reportviewer.GetEmbedTile, { observe: 'response' });
  }

  getProjectsdetailsFrReport(userId) {
    return this.http.get(RptConfig.EndPoint.Reportviewer.GetProjectsdetailsFrReport + '/' + userId);
  }

}
